// Misma regla efectiva de complejidad que PortalEInvoice (UserController.cs:216-223)
// y que el backend (auth.controller.ts): mínimo 8 caracteres, al menos 1
// mayúscula, 1 minúscula y 1 carácter especial.
export const PASSWORD_COMPLEXITY_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).{8,}$/;
export const PASSWORD_COMPLEXITY_MESSAGE =
  'La contraseña debe contener como mínimo 8 caracteres, con al menos una letra minúscula, una letra mayúscula y un carácter especial.';
